<template>
  <dialog-frame v-if="isDisplay" @click-background="closeDialog">
    <div class="confirmTop" :style="borderStyles">
      <div class="close-button-position-absolute" @click="closeDialog">x</div>
      <div class="message-area">
        <slot></slot>
      </div>
      <div style="text-align:center;">
          <button class="btn btn-primary" style="min-width: 7rem;padding: 0.5rem 1rem;" @click="execute">{{yesButton}}</button>
          <button class="btn btn-outline-primary" style="min-width: 7rem;padding: 0.5rem 1rem;" @click="closeDialog">{{noButton}}</button>
      </div>
    </div>
  </dialog-frame>
</template>


<script lang="ts">
import RootVue from '@/RootVue.vue';
import { Vue, Options } from 'vue-class-component';
import DialogFrame from '@/component/dialog/DialogFrame.vue'
@Options({
  components: {
    DialogFrame,
  },
  props:{
    yesButton:{
      type:String,
    },
    noButton:{
      type:String,
      default: "キャンセル",
    },
    borderStyles:{
      type:Object,
      default: undefined
    }
  }
})
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;
  isDisplay = false;
  
  readonly yesButton!:string;
  readonly noButton!:string;
  readonly borderStyles!:any;

  resolve:Function|null = null;
  reject:Function|null = null;

  //親から呼び出し用
  public async openDialog():Promise<boolean>{
    this.isDisplay = true;
    
    return new Promise((resolve, reject)=>{
      this.resolve = resolve
      this.reject = reject
    });
  }

  //親から呼び出し用
  public closeDialog(){
    this.isDisplay = false;
    if(this.resolve) this.resolve(false)
    this.resolve = null
    this.reject = null
  }

  execute(){
    this.isDisplay = false;
    if(this.resolve) this.resolve(true)
    this.resolve = null
    this.reject = null
  }
}
</script>

<style lang="scss" scoped>
  .confirmTop{
    position:relative;
    min-width:12rem;
    padding: 1.7rem 0 .7rem 0;
  }
  .close-button-position-absolute{
    position: absolute;
    top: 0;
    right: 0;
    padding: .4rem .9rem .3rem 1rem;
    cursor: pointer;
    user-select: none;
  }
  .message-area{
    padding: 0 1rem 0 1rem;
    overflow-y: auto;
  }
  button{
    margin: 10px;
  }
</style>